module.exports = __webpack_public_path__ + "static/media/sistemaPegar5.59798ccc.jpg";